import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { feedbackApi, FeedbackListParams, FeedbackReplyPayload } from '@/api/feedback';
import { useActionFeedback } from '@/hooks/useActionFeedback';

export const useFeedbackList = (params: FeedbackListParams = {}) =>
  useQuery({
    queryKey: ['feedback', params],
    queryFn: () => feedbackApi.getAll(params),
  });

export const useReplyFeedback = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: FeedbackReplyPayload }) => feedbackApi.reply(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['feedback'] });
      feedback.success('Balasan feedback berhasil disimpan');
    },
    onError: (error) => {
      feedback.error('Gagal menyimpan balasan feedback', error);
    },
  });
};
